import { Injectable } from '@angular/core';
import { TablesComponent } from './tables.component';

@Injectable({
  providedIn: 'root'
})
export class TablesService {

  params_event : any ;
  tablas : any = {};
  fila_seleccionada = -1;

  constructor() { }
}
